<atomic-message-bar type="info" class="my-10 flex"
	>Use the arrow controls below to select details from the mortgage instructions
	into your matter.</atomic-message-bar
>

<app-container>
	<app-llc-sync-header></app-llc-sync-header>

	<!-- showPriceOveride -->
	<div class="flex" *ngIf="showPriceOveride && llcPurchasePrice">
		<div class="flex-1">
			<app-input
				label="Purchase Price"
				type="cents"
				[disabled]="true"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="llcPurchasePrice"
			></app-input>
		</div>
		<div class="syncOption">
			<app-checkbox
				type="toggle"
				[icon]="ICON.OVERRIDE"
				[ngModel]="overridePurchasePrice"
				(ngModelChange)="updatePurchasePrice($event)"
			></app-checkbox>
		</div>
		<div class="flex-1">
			<app-input
				type="cents"
				label="Purchase Price"
				[startIcon]="ICON.DOLLAR"
				[ngModel]="purchasePrice"
			></app-input>
		</div>
	</div>

	<div class="flex" *ngIf="llcClosingDate">
		<div class="flex-1">
			<app-input
				label="Closing date"
				[disabled]="true"
				[endIcon]="ICON.CALENDAR"
				[ngModel]="llcClosingDate"
			></app-input>
		</div>
		<div class="syncOption">
			<app-checkbox
				type="toggle"
				[icon]="ICON.OVERRIDE"
				[ngModel]="overrideClosingDate"
				(ngModelChange)="updateClosingDate($event)"
			></app-checkbox>
		</div>
		<div class="flex-1">
			<app-input
				label="Closing date"
				[endIcon]="ICON.CALENDAR"
				[ngModel]="closingDate"
			></app-input>
		</div>
	</div>

	<div class="flex mt-3" *ngIf="llcAddressString">
		<div class="flex-1">
			<app-input
				label="Property address"
				[disabled]="true"
				[endIcon]="ICON.HOME"
				[ngModel]="llcAddressString"
			></app-input>
		</div>
		<div class="syncOption">
			<app-checkbox
				type="toggle"
				[icon]="ICON.OVERRIDE"
				[ngModel]="overridePropertyAddress"
				(ngModelChange)="updateAddress($event)"
			></app-checkbox>
		</div>
		<div class="flex-1">
			<app-input
				label="Property address"
				[endIcon]="ICON.HOME"
				[ngModel]="address"
			></app-input>
		</div>
	</div>

	<div class="flex" *ngIf="llcEstateType">
		<div class="flex-1">
			<app-input
				label="Estate type"
				[disabled]="true"
				[ngModel]="llcEstateType"
			></app-input>
		</div>
		<div class="syncOption">
			<app-checkbox
				type="toggle"
				[icon]="ICON.OVERRIDE"
				[ngModel]="overrideEstateType"
				(ngModelChange)="updateEstateType($event)"
			></app-checkbox>
		</div>
		<div class="flex-1">
			<app-input label="Estate type" [ngModel]="estateType"></app-input>
		</div>
	</div>

	<div class="flex mt-3" *ngIf="llcLegalDescription">
		<div class="flex-1">
			<app-input
				label="Legal description"
				[disabled]="true"
				[ngModel]="llcLegalDescription"
			></app-input>
		</div>
		<div class="syncOption">
			<app-checkbox
				type="toggle"
				[icon]="ICON.OVERRIDE"
				[ngModel]="overrideLegalDescription"
				(ngModelChange)="updateLegalDescription($event)"
			></app-checkbox>
		</div>
		<div class="flex-1">
			<app-input
				label="Legal description"
				[ngModel]="legalDescription"
			></app-input>
		</div>
	</div>

	<ng-container *ngFor="let client of clientsVM">
		<div class="flex mt-3" *ngIf="client.llcAddressString">
			<div class="flex-1 flex-col">
				<app-input
					[label]="client.llcClientName + ' address:'"
					[disabled]="true"
					[ngModel]="client.llcAddressString"
				></app-input>
			</div>
			<div class="syncOption">
				<app-checkbox
					type="toggle"
					[icon]="ICON.OVERRIDE"
					[ngModel]="client.overrideAddress"
					(ngModelChange)="updateClientAddress(client, $event)"
				></app-checkbox>
			</div>
			<div class="flex-1 flex-col">
				<span></span>
				<app-input
					[label]="client.closerClientName + ' address:'"
					[disabled]="true"
					[ngModel]="client.model"
				></app-input>
			</div>
		</div>
		<div class="flex flex-col mt-3" *ngIf="client.llcSpouseName">
			<div class="flex">
				<div class="flex-1 flex-col">
					<app-input
						[label]="client.llcClientName + ' spouse:'"
						[disabled]="true"
						[ngModel]="client.llcSpouseName"
					></app-input>
				</div>
				<div class="syncOption"></div>
				<div class="flex-1 flex-col">
					<app-input
						[label]="client.closerClientName + ' spouse:'"
						[disabled]="true"
						[ngModel]="client?.closerSpouse | clientName"
					></app-input>
				</div>
			</div>
			<div class="mt-1">
				<atomic-message-bar type="warn"
					>To set {{ client?.closerClientName }}'s spouse please go to the
					parties section and manually update.</atomic-message-bar
				>
			</div>
		</div>
	</ng-container>
</app-container>

<div class="flex flex-1 justify-end mt-10">
	<app-button btn="secondary" (click)="_next()" size="small" class="mr-3"
		>Skip</app-button
	>
	<app-button (click)="_next()" size="small" [loading]="loading"
		>Sync and continue</app-button
	>
</div>
